class ContactApi {

    constructor(seamApi) {
        this.api = seamApi;
    }
    
    message(params, validationCallback = this.defaultValidationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/contacts/message`, params, validationCallback);
            return response.data.data;
        });
    }

    async message(params = {}, validationCallback) {
        return  await this.api.post('/contacts/message', params, validationCallback);
    }

}


export default ContactApi;
